import React, { forwardRef, useEffect, useState } from "react";
import Checkbox from "@streeteasy/design-system/deprecated/Checkbox";
import RadioButton from "@streeteasy/design-system/deprecated/RadioButton";
import { get } from "lodash";
import { node, oneOf, shape, string } from "prop-types";
import uuid from "uuid/v4";

import Switch from "src/shared/components/Switch";

import {
  formikInjectedFieldPropTypes,
  formikInjectedFormPropTypes
} from "../formikPropTypes";
import InputWrapper from "../InputWrapper";
import {
  handleFieldBlur,
  handleFieldChange,
  handleFieldFocus,
  setChecked
} from "../utilities";

const InputTypes = {
  checkbox: Checkbox,
  radio: RadioButton,
  switch: Switch
};
const ChoiceInput = forwardRef(
  ({ children, className, field, form, type, ...props }, ref) => {
    const FieldComponent = InputTypes?.[type] ?? InputTypes.checkbox;
    const inputProps = { ...props, ...field };
    const [isChecked, setIsChecked] = useState(false);
    let inputType;
    const fieldId = inputProps.id || uuid();
    const fieldError = get(form.errors, field.name);
    const { name: fieldName, value: fieldValue } = field;

    useEffect(() => {
      const formValue = get(form.values, fieldName);
      const checkedValue = setChecked({
        fieldValue,
        formValue,
        type
      });

      setIsChecked(checkedValue);
    }, [form, fieldValue, fieldName, type]);

    switch (type) {
      case "switch": {
        inputType = "checkbox";
        break;
      }
      default: {
        inputType = type;
      }
    }

    return (
      <InputWrapper className={className}>
        <FieldComponent
          ref={ref}
          {...inputProps}
          /* for radio buttons */
          checked={isChecked}
          className={inputProps.inputClassName}
          disabled={inputProps.disabled ?? inputProps.isDisabled}
          id={fieldId}
          /* for checkboxes */
          isChecked={isChecked}
          isInvalid={Boolean(fieldError)}
          onBlur={handleFieldBlur({ field, props })}
          onChange={handleFieldChange({ field, props })}
          onFocus={handleFieldFocus({ field, props })}
          type={inputProps.isHidden ? "hidden" : inputType}
        />
        {children}
      </InputWrapper>
    );
  }
);

ChoiceInput.displayName = "Input_ChoiceInput";

ChoiceInput.propTypes = {
  children: node,
  className: string,
  field: shape(formikInjectedFieldPropTypes).isRequired,
  form: shape(formikInjectedFormPropTypes).isRequired,
  type: oneOf(["checkbox", "radio", "switch"]).isRequired
};

ChoiceInput.defaultProps = {
  children: null,
  className: null
};
export default ChoiceInput;
